import { Link } from "react-router-dom"
import { TOOL_CATEGORIES, toolsRegistry, ToolCategory } from "../toolRegistry"

export default function CategorySidebar({ activeSlug }: { activeSlug?: string }) {
  // Group tools by category
  const toolsByCategory = (Object.keys(TOOL_CATEGORIES) as ToolCategory[]).map((cat) => ({
    id: cat,
    label: TOOL_CATEGORIES[cat].label,
    tools: toolsRegistry.filter((t) => t.category === cat),
  }))

  return (
    <nav className="space-y-8 pb-8">
      {toolsByCategory.map((category) => {
        if (category.tools.length === 0) return null

        return (
          <div key={category.id}>
            <h4 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
              {category.label}
            </h4>
            <ul className="space-y-1">
              {category.tools.map((tool) => {
                const isActive = activeSlug === tool.slug
                return (
                  <li key={tool.slug}>
                    <Link
                      to={`/tools/${tool.slug}`}
                      className={`block px-3 py-2 -mx-3 rounded-md text-sm transition-colors ${
                        isActive
                          ? "bg-primary/10 text-primary font-medium"
                          : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
                      }`}
                    >
                      {tool.shortTitle}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })}
    </nav>
  )
}
